import React, { useRef, useState } from 'react';
import { Breadcrumbs, Button, IconButton, InputBase, Paper, Stack, Typography, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Search, Upload, Add, FilterList, UploadOutlined, Opacity, PlaylistAdd } from '@mui/icons-material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Bulkupload, Delete, Export, Filter } from '../../Svg';

// Styled components
const SearchInput = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  width: '320px',
  fontFamily: `'Public Sans', sans-serif`,
}));

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

const AddCategoryButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '0.875rem',
  backgroundColor: '#512DA8',
  color: '#fff',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: '#512DA8',
    opacity: '0.65',
  },
}));


const status = ['OUT OF STOCK', 'PUBLISHED', 'DRAFT']
const MasterHeader = ({ deleteAll, deleteLoading, root, index, prev, setStatus, setSearch, handleFileChange, onClickadd, buttonText, exportData, exportLoading, hideBulk, hideStatus = false, hideExport = false, hideStatus2 = false, onQuickList }) => {

  const navigate = useNavigate()
  const fileInputRef = useRef(null);
  const dispatch = useDispatch()

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };



  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (status) => {
    if (status) {
      setStatus(status)

    }
    setAnchorEl(null);
  };

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ flexWrap: 'wrap', gap: 2 }}>
        {/* Breadcrumbs and Title */}
        <Stack spacing={1}>
          <Typography
            sx={{
              color: 'rgba(29, 31, 44, 1)',
              fontSize: '24px',
              fontWeight: '600',
              fontFamily: `'Public Sans', sans-serif`,
            }}>
            {index}
          </Typography>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            <Typography color="text.secondary"
              sx={{
                fontSize: '14px',
                fontFamily: `'Public Sans', sans-serif`,
              }}>{root}
            </Typography>
            <Typography color="text.primary"
              sx={{
                fontSize: '14px',
                fontFamily: `'Public Sans', sans-serif`,
              }}> {index}
            </Typography>
          </Breadcrumbs>
        </Stack>

        {/* Search and Action Buttons */}
        <Stack direction="row" alignItems="center" spacing={1} sx={{ flexWrap: 'wrap', gap: 1 }}>

          {
            deleteAll ? <ActionButton onClick={deleteAll} disabled={deleteLoading}><Delete /> {deleteLoading ? "please wait..." : "Delete"} </ActionButton>
              : null
          }
          {
            !hideExport &&
            <ActionButton onClick={exportData} disabled={exportLoading}><Export /> {exportLoading ? "please wait..." : "Export"} </ActionButton>

          }

          {hideBulk !== 'hide' ?
            <div>
              <ActionButton onClick={handleButtonClick}>
                <Bulkupload />
                Bulk upload</ActionButton>
              <input
                type="file"
                accept=".xlsx, .xls"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />
            </div>
            : null}
          {onQuickList ? (
            <ActionButton onClick={onQuickList}>
              <PlaylistAdd sx={{ mr: 0.5, fontSize: 20 }} />
              Quick List</ActionButton>
          ) : null}
          <AddCategoryButton startIcon={<Add />} onClick={onClickadd}>{buttonText}</AddCategoryButton>
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ padding: '20px 0px' }}>
        <SearchInput component="form" onSubmit={(e) => e.preventDefault()} autoComplete="off">
          <IconButton aria-label="search">
            <Search />
          </IconButton>
          <InputBase
            placeholder="Search…"
            name="product_search_filter"
            id="product_search_filter"
            type="search"
            inputProps={{ autoComplete: 'off' }}
            onChange={(e) => setSearch(e.target.value)}
          />
        </SearchInput>
        {!hideStatus &&
          <div>
            <ActionButton
              onClick={handleClick}
              sx={{
                color: '#667085',
                border: '1px solid #E0E2E7',
                background: '#fff',
                borderRadius: '8px',
              }}
            >
              <Filter /> Status
            </ActionButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => handleClose('')}
              MenuListProps={{
                'aria-labelledby': 'status-button',
              }}
            >
              <MenuItem onClick={() => handleClose('ACTIVE')}
                sx={{
                  borderBottom: '1px solid #E6E1E5',
                  fontSize: '14px',
                  color: '#667085',
                }}>Active</MenuItem>
              <MenuItem onClick={() => handleClose('INACTIVE')}
                sx={{
                  fontSize: '14px',
                  color: '#667085',
                }}>Inactive</MenuItem>
            </Menu>
          </div>
        }

        {!hideStatus2 && hideStatus &&
          <div>
            <ActionButton
              onClick={handleClick}
              sx={{
                color: '#667085',
                border: '1px solid #E0E2E7',
                background: '#fff',
                borderRadius: '8px',
              }}
            >
              <Filter /> Status
            </ActionButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => handleClose('')}
              MenuListProps={{
                'aria-labelledby': 'status-button',
              }}
            >
              {status.map((i) => (

                <MenuItem onClick={() => handleClose(i)}
                  sx={{
                    borderBottom: '1px solid #E6E1E5',
                    fontSize: '14px',
                    color: '#667085',
                  }}>{i}</MenuItem>
              ))
              }
            </Menu>
          </div>
        }
      </Stack>
    </>
  );
};

export default MasterHeader;
